import type { SystemEventResponse } from '../../types/event.types';

export interface EventBus {
    publish(message: SystemEventResponse): void;
    subscribe(listener: (message: SystemEventResponse) => void): () => void;
}

export const createEventBus = (): EventBus => {
    const listeners = new Set<(message: SystemEventResponse) => void>();

    return {
        publish: (message) => {
            listeners.forEach((listener) => listener(message));
        },
        subscribe: (listener) => {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
    };
};

export const eventBus = createEventBus();
